var map = {
	"./abacus.png": [
		6686,
		6686
	],
	"./alcohol.png": [
		8224,
		8224
	],
	"./alientech.png": [
		55,
		55
	],
	"./amber.png": [
		5213,
		5213
	],
	"./amber2.png": [
		2051,
		2051
	],
	"./amber_amulett.png": [
		3995,
		3995
	],
	"./ambra.png": [
		3163,
		3163
	],
	"./amethyst.png": [
		6574,
		6574
	],
	"./amethyst2.png": [
		9157,
		9157
	],
	"./amethyst_ring.png": [
		3300,
		3300
	],
	"./anchor.png": [
		5328,
		5328
	],
	"./antlers.png": [
		4186,
		4186
	],
	"./apple.png": [
		322,
		322
	],
	"./ark.png": [
		9653,
		9653
	],
	"./backpack.png": [
		4568,
		4568
	],
	"./badge.png": [
		2285,
		2285
	],
	"./barrel.png": [
		2670,
		2670
	],
	"./bell.png": [
		4823,
		4823
	],
	"./black_fabric.png": [
		959,
		959
	],
	"./black_powder.png": [
		7559,
		7559
	],
	"./blank_canvas.png": [
		3070,
		3070
	],
	"./blanket.png": [
		7636,
		7636
	],
	"./block_of_wood.png": [
		8446,
		8446
	],
	"./blood.png": [
		6535,
		6535
	],
	"./bloody_knife.png": [
		4355,
		4355
	],
	"./bloody_rags.png": [
		45,
		45
	],
	"./blue_crystal.png": [
		5164,
		5164
	],
	"./blueprint.png": [
		8959,
		5527
	],
	"./boat.png": [
		4970,
		4970
	],
	"./bone_fragments.png": [
		2422,
		2422
	],
	"./book1.png": [
		150,
		150
	],
	"./book2.png": [
		844,
		844
	],
	"./book_of_spells.png": [
		4586,
		7317
	],
	"./book_with_eyes.png": [
		7975,
		7975
	],
	"./books.png": [
		5623,
		5623
	],
	"./boot.png": [
		9547,
		9547
	],
	"./bottle.png": [
		9937,
		9937
	],
	"./bottle_of_rum.png": [
		9736,
		9736
	],
	"./bread.png": [
		8291,
		8291
	],
	"./broken_thing.png": [
		6543,
		6543
	],
	"./broom.png": [
		3274,
		3274
	],
	"./broom_magic.png": [
		4917,
		4917
	],
	"./brush.png": [
		5060,
		5060
	],
	"./bug.png": [
		9958,
		9958
	],
	"./bug_gold.png": [
		7571,
		7571
	],
	"./bug_mech.png": [
		7591,
		7591
	],
	"./bulb.png": [
		5937,
		5937
	],
	"./bullet.png": [
		413,
		413
	],
	"./calcinator.png": [
		5567,
		5567
	],
	"./caleidoscope.png": [
		8451,
		8451
	],
	"./calendar.png": [
		8387,
		8387
	],
	"./camera.png": [
		2024,
		2024
	],
	"./canary_bird.png": [
		1653,
		1653
	],
	"./candle_light_dinner.png": [
		6900,
		6900
	],
	"./candles.png": [
		8410,
		8410
	],
	"./canvas_ship.png": [
		3682,
		3682
	],
	"./captains_hat.png": [
		1033,
		1033
	],
	"./carpet_flying.png": [
		1774,
		1774
	],
	"./carpet_old.png": [
		9565,
		9565
	],
	"./carpet_persian.png": [
		2172,
		2172
	],
	"./cat.png": [
		2950,
		2950
	],
	"./celestial_map.png": [
		4405,
		4405
	],
	"./chameleon.png": [
		8867,
		8867
	],
	"./chandalier.png": [
		5739,
		5739
	],
	"./chemicals.png": [
		3726,
		3726
	],
	"./chest.png": [
		1397,
		1397
	],
	"./chili.png": [
		9622,
		9622
	],
	"./chimes.png": [
		4060,
		4060
	],
	"./chocolate.png": [
		1826,
		1826
	],
	"./cloak.png": [
		9626,
		5627
	],
	"./coal.png": [
		7188,
		7188
	],
	"./coconut.png": [
		1054,
		1054
	],
	"./coconut_oil.png": [
		5998,
		4392
	],
	"./coffee.png": [
		7033,
		7033
	],
	"./coffee2.png": [
		4907,
		4907
	],
	"./coffin.png": [
		4543,
		4543
	],
	"./colors.png": [
		3092,
		3092
	],
	"./compass.png": [
		2113,
		2113
	],
	"./conch.png": [
		4248,
		4248
	],
	"./confession.png": [
		3243,
		3243
	],
	"./cooking_book.png": [
		8069,
		8069
	],
	"./cooking_pot.png": [
		5853,
		5853
	],
	"./copper_wire.png": [
		1570,
		1570
	],
	"./coral.png": [
		5958,
		5958
	],
	"./cotton.png": [
		6186,
		6186
	],
	"./crab.png": [
		2419,
		2419
	],
	"./cruzifix.png": [
		2803,
		2803
	],
	"./crystal_ball.png": [
		8761,
		8959
	],
	"./crystal_glass.png": [
		5019,
		5019
	],
	"./crystal_skull.png": [
		15,
		15
	],
	"./crystals.png": [
		1906,
		1906
	],
	"./curtains.png": [
		5398,
		875
	],
	"./cylinder.png": [
		282,
		282
	],
	"./dagger.png": [
		967,
		967
	],
	"./dagger2.png": [
		508,
		508
	],
	"./death_bell.png": [
		292,
		292
	],
	"./death_mask.png": [
		5392,
		5392
	],
	"./deck_of_cards.png": [
		9113,
		9113
	],
	"./deer.png": [
		1434,
		1434
	],
	"./diamond.png": [
		3155,
		3155
	],
	"./diamond2.png": [
		7569,
		7569
	],
	"./diamond_cutter.png": [
		8256,
		8256
	],
	"./diamond_ring.png": [
		6770,
		6770
	],
	"./dinosaur_bones.png": [
		2221,
		2221
	],
	"./distillery.png": [
		9187,
		9187
	],
	"./doll.png": [
		7204,
		7204
	],
	"./dragon.png": [
		1094,
		1094
	],
	"./dragon_egg.png": [
		3771,
		3771
	],
	"./dream_catcher.png": [
		9142,
		1982
	],
	"./dress.png": [
		408,
		408
	],
	"./dusty_painting.png": [
		776,
		776
	],
	"./egypt.png": [
		9096,
		9096
	],
	"./electric_eel.png": [
		5743,
		5743
	],
	"./emerald.png": [
		9286,
		9286
	],
	"./emerald2.png": [
		5338,
		5338
	],
	"./emerald_pendant.png": [
		9102,
		9102
	],
	"./empty_jar.png": [
		8821,
		8821
	],
	"./encyclopedia.png": [
		7268,
		7268
	],
	"./essential_oil.png": [
		5002,
		5002
	],
	"./etherial_sails.png": [
		1257,
		1257
	],
	"./even_more_broken_thing.png": [
		7874,
		7874
	],
	"./evidence.png": [
		5541,
		5541
	],
	"./evidence2.png": [
		638,
		638
	],
	"./faberge_egg.png": [
		2377,
		2377
	],
	"./fairytales.png": [
		3484,
		3484
	],
	"./fan.png": [
		107,
		107
	],
	"./feast-m.png": [
		708,
		708
	],
	"./feathers.png": [
		4001,
		4001
	],
	"./first_aid.png": [
		8351,
		8351
	],
	"./fish_bucket.png": [
		7421,
		7421
	],
	"./fish_trap.png": [
		9682,
		9682
	],
	"./fishing_net.png": [
		5827,
		5827
	],
	"./fishing_rod.png": [
		8405,
		8405
	],
	"./fishing_rod_m.png": [
		4221,
		4221
	],
	"./flare.png": [
		9437,
		9437
	],
	"./flask.png": [
		5542,
		5542
	],
	"./flax.png": [
		1662,
		1662
	],
	"./flower_glowing.png": [
		9708,
		9708
	],
	"./flute.png": [
		2261,
		2261
	],
	"./fox.png": [
		7721,
		7721
	],
	"./fresh_sails.png": [
		4215,
		4215
	],
	"./frying_pan.png": [
		4732,
		4732
	],
	"./giant_fly.png": [
		8731,
		8731
	],
	"./glasses.png": [
		158,
		158
	],
	"./globus.png": [
		7323,
		7323
	],
	"./gloves.png": [
		2373,
		2373
	],
	"./golden_fleece.png": [
		4474,
		4474
	],
	"./golden_yarn.png": [
		8386,
		8386
	],
	"./goldfish.png": [
		7059,
		7059
	],
	"./gown.png": [
		6702,
		6702
	],
	"./gramophone.png": [
		3202,
		3202
	],
	"./greek_statue.png": [
		6230,
		6230
	],
	"./groomed_cat.png": [
		5021,
		5021
	],
	"./hammer.png": [
		8443,
		8443
	],
	"./hand_cuffs.png": [
		5703,
		5703
	],
	"./haunting_dream.png": [
		7580,
		2090
	],
	"./heart.png": [
		1178,
		1178
	],
	"./hemlock.png": [
		3976,
		3976
	],
	"./herbs_m_2.png": [
		5878,
		5878
	],
	"./hides.png": [
		1886,
		1886
	],
	"./holy_book.png": [
		2965,
		2965
	],
	"./holy_grail.png": [
		9347,
		9347
	],
	"./holy_water.png": [
		8011,
		8011
	],
	"./honey.png": [
		3097,
		3097
	],
	"./hourglass.png": [
		4922,
		4922
	],
	"./human_hair.png": [
		4292,
		4292
	],
	"./hunting_rifle.png": [
		7022,
		7022
	],
	"./hymn_book.png": [
		9737,
		9737
	],
	"./icons.png": [
		3478,
		3478
	],
	"./imp.png": [
		3453,
		3453
	],
	"./incence_sticks.png": [
		7176,
		7176
	],
	"./ink_and_quill.png": [
		1164,
		5398
	],
	"./insurance.png": [
		6412,
		6412
	],
	"./invisibility_cloak.png": [
		4239,
		4239
	],
	"./jar_with_bug.png": [
		4044,
		4044
	],
	"./jellyfish.png": [
		9725,
		9725
	],
	"./karmasutra.png": [
		7093,
		7093
	],
	"./kitchen_knife.png": [
		7412,
		7412
	],
	"./klabautermann.png": [
		811,
		811
	],
	"./krakenfang.png": [
		1168,
		1168
	],
	"./lantern.png": [
		2486,
		2486
	],
	"./laudanum.png": [
		6945,
		6945
	],
	"./leather_ball.png": [
		6852,
		6852
	],
	"./leech.png": [
		4602,
		4602
	],
	"./lighter.png": [
		7857,
		7857
	],
	"./lip_stick.png": [
		6545,
		6545
	],
	"./lockpick.png": [
		900,
		900
	],
	"./love_letter.png": [
		4380,
		4380
	],
	"./lumber.png": [
		5521,
		5521
	],
	"./lute.png": [
		9856,
		9856
	],
	"./lute_broken.png": [
		3306,
		3306
	],
	"./magnifying_glass.png": [
		8104,
		8104
	],
	"./map.png": [
		6500,
		6500
	],
	"./marble.png": [
		864,
		864
	],
	"./marbles.png": [
		4017,
		4017
	],
	"./marlin.png": [
		6825,
		6825
	],
	"./mask1.png": [
		6713,
		6713
	],
	"./medal.png": [
		3917,
		3917
	],
	"./met.png": [
		7355,
		7355
	],
	"./meteorite.png": [
		3844,
		3844
	],
	"./microscope.png": [
		7334,
		7334
	],
	"./ming.png": [
		9320,
		9320
	],
	"./mint.png": [
		1524,
		1524
	],
	"./mjoelnir.png": [
		555,
		555
	],
	"./monkey.png": [
		4849,
		4849
	],
	"./monkey_head.png": [
		1585,
		1585
	],
	"./monkey_mutant.png": [
		3791,
		3791
	],
	"./mortar_pestle.png": [
		6503,
		6503
	],
	"./mourning_veil.png": [
		8732,
		8732
	],
	"./mushroom_glowing.png": [
		6098,
		6098
	],
	"./mushrooms.png": [
		7155,
		7155
	],
	"./musk.png": [
		3229,
		3229
	],
	"./mutagen.png": [
		381,
		381
	],
	"./nightmare.png": [
		3198,
		3198
	],
	"./nightshade.png": [
		3660,
		3660
	],
	"./observatory.png": [
		9558,
		9558
	],
	"./octopus.png": [
		2492,
		2492
	],
	"./officers_uniform.png": [
		4923,
		4923
	],
	"./old_hat.png": [
		2348,
		2348
	],
	"./organ.png": [
		5887,
		5887
	],
	"./oyster.png": [
		1273,
		1273
	],
	"./painting.png": [
		7739,
		7739
	],
	"./paper.png": [
		1550,
		1550
	],
	"./parot.png": [
		8067,
		8067
	],
	"./pelt_coat.png": [
		1865,
		1865
	],
	"./perfume1.png": [
		9968,
		9968
	],
	"./perfume2.png": [
		4990,
		4990
	],
	"./phasmatodea.png": [
		9729,
		9729
	],
	"./pine.png": [
		7258,
		7258
	],
	"./pipe.png": [
		4050,
		4050
	],
	"./poison.png": [
		7735,
		7735
	],
	"./poppy.png": [
		3025,
		3025
	],
	"./powder.png": [
		8010,
		8010
	],
	"./prism.png": [
		4348,
		4348
	],
	"./pronged_dice.png": [
		7461,
		7461
	],
	"./puzzle1.png": [
		5517,
		5517
	],
	"./puzzle2.png": [
		6953,
		6953
	],
	"./puzzle3.png": [
		4342,
		4342
	],
	"./puzzle4.png": [
		7353,
		7353
	],
	"./puzzle_box.png": [
		4778,
		4778
	],
	"./rabbit.png": [
		8289,
		8289
	],
	"./rabbits_foot.png": [
		991,
		991
	],
	"./rags.png": [
		2896,
		4586
	],
	"./rainbow_feather.png": [
		1936,
		9142
	],
	"./raven.png": [
		3107,
		3107
	],
	"./red-snapper.png": [
		1268,
		1268
	],
	"./resin.png": [
		861,
		861
	],
	"./revived_reptile.png": [
		3170,
		3170
	],
	"./revolver.png": [
		6438,
		6438
	],
	"./rifle.png": [
		6563,
		6563
	],
	"./rifle_jammed.png": [
		7172,
		7172
	],
	"./roasted_fish.png": [
		1334,
		1334
	],
	"./rosary.png": [
		6272,
		6272
	],
	"./rose.png": [
		9091,
		9091
	],
	"./ruby.png": [
		5069,
		5069
	],
	"./ruby2.png": [
		4763,
		4763
	],
	"./ruby_crown.png": [
		2081,
		2081
	],
	"./saint_pendant.png": [
		3422,
		3422
	],
	"./salt.png": [
		2104,
		2104
	],
	"./sandals.png": [
		7299,
		7299
	],
	"./saphire.png": [
		248,
		248
	],
	"./saphire2.png": [
		395,
		395
	],
	"./saphire_bracelet.png": [
		6988,
		6988
	],
	"./sauce.png": [
		8188,
		8188
	],
	"./scarf.png": [
		9139,
		9139
	],
	"./sceptre.png": [
		9555,
		9555
	],
	"./scissors1.png": [
		8547,
		8547
	],
	"./scissors2.png": [
		9557,
		9557
	],
	"./screws.png": [
		516,
		516
	],
	"./seagrass.png": [
		4709,
		4709
	],
	"./sewing_kit.png": [
		9610,
		9610
	],
	"./sewing_machine.png": [
		1981,
		1981
	],
	"./sextant.png": [
		3077,
		3077
	],
	"./shark_head.png": [
		2581,
		2581
	],
	"./ship_in_a_bottle.png": [
		6790,
		6790
	],
	"./shrunken_head.png": [
		8044,
		8044
	],
	"./signal_horn.png": [
		1042,
		1042
	],
	"./signet_ring.png": [
		3891,
		3891
	],
	"./silverware.png": [
		2515,
		2515
	],
	"./siren.png": [
		7757,
		7757
	],
	"./skull.png": [
		7413,
		7413
	],
	"./sleeping_bag.png": [
		6733,
		6733
	],
	"./sniff_box.png": [
		5331,
		5331
	],
	"./spider.png": [
		666,
		666
	],
	"./spinning_wheel.png": [
		1187,
		1187
	],
	"./star_of_betlehem.png": [
		6968,
		6968
	],
	"./stars.png": [
		1390,
		5842
	],
	"./steam_engine.png": [
		1665,
		1665
	],
	"./stew.png": [
		3072,
		3072
	],
	"./straw.png": [
		1627,
		1627
	],
	"./sword.png": [
		2137,
		2137
	],
	"./swordfish.png": [
		7493,
		7493
	],
	"./syringe.png": [
		6314,
		6314
	],
	"./talisman.png": [
		4277,
		4277
	],
	"./tea.png": [
		6974,
		6974
	],
	"./teddy.png": [
		571,
		571
	],
	"./telescope.png": [
		956,
		956
	],
	"./tentacle_monster.png": [
		3031,
		3031
	],
	"./time_machine.png": [
		436,
		436
	],
	"./torn_sails.png": [
		5085,
		5085
	],
	"./translation.png": [
		4006,
		4006
	],
	"./treasure.png": [
		9250,
		9250
	],
	"./treaty.png": [
		7935,
		7935
	],
	"./trident.png": [
		9541,
		9541
	],
	"./trout.png": [
		2795,
		2795
	],
	"./tuna.png": [
		3675,
		3675
	],
	"./twigs.png": [
		7952,
		7952
	],
	"./unicorn.png": [
		9651,
		9651
	],
	"./universe.png": [
		7734,
		7734
	],
	"./urn.png": [
		3356,
		3356
	],
	"./vibrant_crystal.png": [
		8503,
		8503
	],
	"./violin.png": [
		2215,
		748
	],
	"./wafers.png": [
		4877,
		4877
	],
	"./walking_stick.png": [
		4143,
		4143
	],
	"./wand.png": [
		963,
		963
	],
	"./watch.png": [
		6559,
		6559
	],
	"./whip_and_hat.png": [
		755,
		755
	],
	"./whistle.png": [
		1204,
		1204
	],
	"./wine.png": [
		5032,
		5032
	],
	"./wolf_medal.png": [
		1407,
		1407
	],
	"./worn_teddy.png": [
		8467,
		8467
	],
	"./wreck.png": [
		6031,
		6031
	],
	"./wrench.png": [
		7724,
		7724
	],
	"./zombie_fish.png": [
		1633,
		1633
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1430;
module.exports = webpackAsyncContext;